<script setup>
import ImoSkeleton from './ImoSkeleton.vue'

defineProps({
  rows: {
    type: Number,
    default: 5,
  },
  columns: {
    type: Number,
    default: 4,
  },
})
</script>

<template>
  <div
    class="border-neutral-30 flex w-full flex-col overflow-hidden rounded-2xl border bg-white"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <span class="sr-only">Carregando tabela…</span>
    <!-- Cabeçalho -->
    <div class="bg-neutral-10 flex gap-4 px-4 py-3">
      <ImoSkeleton v-for="col in columns" :key="`head-${col}`" height="0.875rem" />
    </div>
    <!-- Linhas -->
    <div
      v-for="row in rows"
      :key="`row-${row}`"
      class="border-neutral-20 flex gap-4 border-t px-4 py-4"
    >
      <ImoSkeleton v-for="col in columns" :key="`cell-${row}-${col}`" height="1rem" />
    </div>
  </div>
</template>
